'use strict';

(function(window, document, $) {
	var $win = $(window);
	var $doc = $(document);
	var $header = $('.header');
	var $headerHeight = $header.outerHeight();
	var isTablet = $win.width() < 1024;



	$win.on('load', function(){
	}).on('load resize',function(){
		headerFix ();
		isTablet = $win.width() < 1024;
		$headerHeight = $header.outerHeight()
	}).on('load scroll', function(){
		stickyHeader();
	})

	AOS.init();

	$('.nav-trigger-holder').on('click', function(event) {
		$('.nav-trigger').toggleClass('nav-trigger--active');
		$(this).toggleClass('active');
		$('.header__navs').toggleClass('expanded');

		event.preventDefault();
	});

	function headerFix () {
		$('.container').css('padding-top', $headerHeight )
	}

	function stickyHeader(){
		if (!isTablet) {
			//console.log(1);
			if ( $header.hasClass('header-js') ) {
				if( $win.scrollTop() >= ($headerHeight * 0.9) ){
					$header.addClass('header--fix');
				}else{
					$header.removeClass('header--fix');
				}
			}
		}
	}

})(window, document, window.jQuery);

( function( $ ) {
	class Pagination {
		constructor( $component ) {
			this.$pagination = $component;
			this.$select = $component.find( '[data-pagination="select"]' );

			this.init = this.init.bind( this );

			this.init();
		}

		init() {
			this.$select.on( 'change', e => {
				window.location.href = e.target.value;
			} );
		}
	}

	$.fn.pagination = function() {
		this.each( function() {
			new Pagination( $( this ) );
		} );
	};

	$( '[data-pagination="component"]' ).pagination();
}( jQuery ) );

( function( $ ) {
	class NavDropdown {
		constructor( $component ) {
			this.$component = $component;
			this.$toggle = $component.find( '[data-navdropdown="toggle"]' );
			this.$submenu = $component.find( '[data-navdropdown="submenu"]' );
			this.$submenuLinks = $component.find( '[data-navdropdown="submenu"] a' );
			this.state = {
				visible: 'submenu-visible',
				hidden: 'submenu-hidden'
			};

			this.keyboard = {
				tab: 9,
				escape: 27,
				up: 38,
				down: 40,
				left: 37,
				right: 39
			};

			this.init = this.init.bind( this );

			this.showDropdown = this.showDropdown.bind( this );
			this.hideDropdown = this.hideDropdown.bind( this );
			this.hideOnEscape = this.hideOnEscape.bind( this );
			this.hideOnClick = this.hideOnClick.bind( this );
			this.handleToggleClick = this.handleToggleClick.bind( this );
			this.stillOnDropdown = this.stillOnDropdown.bind( this );
			this.positionSubmenu = this.positionSubmenu.bind( this );

			this.init();
		}

		showDropdown() {
			// Dont re-bind if focusing back
			if ( this.$component.hasClass( this.state.visible ) ) {
				return;
			}

			this.positionSubmenu();

			// Show submenu
			this.$component
				.removeClass( this.state.hidden )
				.addClass( this.state.visible );

			// Hide submenu if no longer hovering on submenu
			this.$component.on( 'mouseout', e => {
				if ( this.stillOnDropdown( $( e.relatedTarget ) ) ) {
					return;
				}

				this.hideDropdown();
			} );

			// Keyboard functionality for toggle
			this.$toggle.on( 'keydown', e => {
				// Hide submenu if toggle tabbed to previous link
				if ( ( e.keyCode === this.keyboard.tab && e.shiftKey ) ) {
					this.hideDropdown();
				}

				// Focus on first submenu link if down arrow pressed
				if ( ( e.keyCode === this.keyboard.down ) ) {
					e.preventDefault();
					this.$submenuLinks.first().focus();
				}
			} );

			// Keyboard arrow key navigation for submenu links
			this.$submenuLinks.on( 'keydown', e => {
				// Down Arrow
				if ( ( e.keyCode === this.keyboard.down ) ) {
					e.preventDefault();
					$( e.currentTarget ).parent().next().find( 'a' ).focus();
				}

				// Up Arrow
				if ( ( e.keyCode === this.keyboard.up ) ) {
					e.preventDefault();
					$( e.currentTarget ).parent().prev().find( 'a' ).focus();
				}
			} );

			// Focus to toggle if up arrow pressed on first submenu link
			this.$submenuLinks.first().on( 'keydown', e => {
				if ( ( e.keyCode === this.keyboard.up ) ) {
					e.preventDefault();
					this.$toggle.focus();
				}
			} );

			// Hide submenu on focus out on last link
			this.$submenuLinks.last().on( 'keydown', e => {
				if ( ( e.keyCode === this.keyboard.tab && ! e.shiftKey ) ) {
					this.hideDropdown();
				}
			} );

			// Hide submenu on escape
			$( document ).on( 'keydown', this.hideOnEscape );

			// Hide submenu on click
			$( document ).on( 'click', this.hideOnClick );
		}

		hideDropdown() {
			this.$component
				.removeClass( this.state.visible )
				.addClass( this.state.hidden );

			// Unbind all events
			this.$component.off( 'mouseout' );
			this.$toggle.off( 'keydown' );
			this.$submenuLinks.off( 'keydown' );
			$( document ).off( 'keydown', this.hideOnEscape );
			$( document ).off( 'click', this.hideOnClick );
		}

		handleToggleClick() {
			// Ignore if link
			if ( this.$toggle.prop( 'tagName' ).toLowerCase() === 'a' ) {
				return;
			}

			// Toggle if button
			if ( this.$component.hasClass( this.state.hidden ) ) {
				this.showDropdown();
			} else {
				this.hideDropdown();
			}
		}

		hideOnEscape( e ) {
			if ( e.keyCode === this.keyboard.escape ) {
				this.hideDropdown();
			}
		}

		hideOnClick( e ) {
			// Only hide if not clicking on toggle
			if ( $( e.target )[ 0 ] === this.$toggle[ 0 ] ) {
				return;
			}

			this.hideDropdown();
		}

		stillOnDropdown( $el ) {
			if ( $el.hasClass( this.state.visible ) ) {
				return true;
			}

			if ( $el.parents( `.${ this.state.visible }` ).length ) {
				return true;
			}

			return false;
		}

		positionSubmenu() {
			const gutter = 15;
			const windowWidth = window.innerWidth;
			const dropdownWidth = this.$component.outerWidth();
			const dropdownLeftPos = this.$component.get( 0 ).offsetLeft;
			const dropdownCenterPos = ( dropdownWidth / 2 ) + dropdownLeftPos;
			const submenuWidth = this.$submenu.outerWidth();

			this.$submenu.removeClass( 'position-right position-left position-center' );

			if ( dropdownCenterPos + ( submenuWidth / 2 ) > windowWidth - gutter ) {
				this.$submenu.addClass( 'position-right' );
				return;
			}

			if ( dropdownCenterPos - ( submenuWidth / 2 ) < gutter ) {
				this.$submenu.addClass( 'position-left' );
				return;
			}

			this.$submenu.addClass( 'position-center' );
		}

		init() {
			this.$toggle.on( 'mouseenter focus', () => {
				this.showDropdown();
			} );

			this.$toggle.on( 'click', () => {
				this.handleToggleClick();
			} );

			// Open dropdown if focus on a submenu link
			this.$submenuLinks.on( 'focus', () => {
				if ( this.$component.hasClass( this.state.hidden ) ) {
					this.showDropdown();
				}
			} );
		}
	}

	$.fn.navDropdown = function() {
		this.each( function() {
			new NavDropdown( $( this ) );
		} );
	};

	$( '[data-navdropdown="component"]' ).navDropdown();
}( jQuery ) );



